export const getSavedActiveProjects = (state: $TSFixMe) =>
  state.settings.activeProjects.map((project: $TSFixMe) => project.id).join(',')

export const getUsersAvailableProjects = (state: $TSFixMe) =>
  state.settings.activeProjects
